import { colorScheema } from '../constants/colorScheema';
import { API_URLS } from '../constants/api_urls';
import api from '../utils/API';

export const getNextColor = async (accountId) => {
  const response = await api.get(
    `${API_URLS.ACCOUNTS_V3}/${accountId}/portfolio`,
    {
      params: { limit: -1, offset: 0 },
    },
  );

  const withoutColor = response?.data?.list?.filter((i) => !i.color);
  let usedColor = response?.data?.list
    ?.filter((i) => i.color)
    ?.map((el) => el.color);

  const getColorQueue = () => {
    const queue = [];
    for (let i = 0; i < 4; i++) {
      queue.push(colorScheema[i]);
      queue.push(colorScheema[i + 4]);
      queue.push(colorScheema[i + 8]);
    }
    return queue;
  };
  const COLOR_QUEUE = getColorQueue();

  const nextColor = () => {
    const available = COLOR_QUEUE.find((color) => !usedColor.includes(color));
    if (available) return available;

    const randomIdx = Math.floor(Math.random() * colorScheema.length);
    return colorScheema[randomIdx];
  };

  for (const portfolio of withoutColor) {
    const next = nextColor();
    try {
      const response = await api.put(`v3/portfolio/${portfolio.id}/color`, {
        color: next,
      });
      const color = await response.data.color;
      usedColor.push(color);
    } catch (err) {
      console.error('Error:', err);
    }
  }

  nextColor();
};
